module.exports = __webpack_public_path__ + "media/images/icons/flags/UA-39f86175742d725cbf093b8663790d57.svg";